export const ADMIN_HOME_ACCORDION_CLASS_NAME =
	"[&>button]:min-h-[68px] [&>button]:border-neutral-3 [&>button]:bg-neutral-1 [&>button]:rounded-2 [&>button[aria-expanded='true']]:rounded-b-none [&>button[aria-expanded='true']]:border-b-transparent [&>button[aria-expanded='true']:hover]:border-b-neutral-3";

export const ADMIN_HOME_BUTTON_CLASS_NAME = "w-fit";
